import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import {makeStyles} from 'external/material'

import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

import {getQuizQuestionStandards} from 'helpers/quiz'

import QuestionProperties from './question-properties'
import QuestionTitle from 'components/quiz/components/question-title'
import QuestionValue from 'components/quiz/components/question-value'

import Dialog from 'components/quiz/components/responsive-fullscreen-dialog'

import {createPost} from 'helpers/command'

import matchingHandler from 'components/quiz/edit-questions/matching'
import fillInTheBlanksHandler from 'components/quiz/edit-questions/fill-in-the-blanks'
import multipleChoiceHandler from 'components/quiz/edit-questions/multiple-choice'
import openQuestionHandler from 'components/quiz/edit-questions/open-question'
import trueOrFalseHandler from 'components/quiz/edit-questions/true-or-false'

import {TeacherContext} from 'teacher/context'

import AddStandard from '../add-standard'

const questionHandlers = {
  'matching': matchingHandler,
  'fill-in-the-blanks': fillInTheBlanksHandler,
  'multiple-choice': multipleChoiceHandler,
  'open-question': openQuestionHandler,
  'true-or-false': trueOrFalseHandler
}

const useStyles = makeStyles(editQuestionStyles)

export default function EditBankQuestion (props) {

  const classes = useStyles()
  const history = useHistory()
  const context = useContext(TeacherContext)

  const {at, translate, updateState, questionId, quizQuestionBank, link, linkQuery, query} = context

  const index = quizQuestionBank.findIndex(q => q.id == questionId)

  const questionPath = `quizQuestionBank[${index}]`
  const [question = {}] = at(questionPath)

  const questionType = context.quizQuestionTypes.find(type => type.id == question.type) || {}
  const Handler = questionHandlers[questionType.name]

  function closeDialog () {
    history.push(link({}, '/:languageId/:role/:page/:tab', {query}))
  }

  async function updateProperties (request, updateCommand) {
    const [updatedId] = request
      ? await createPost('quiz', 'updateQuestionProperties')(request)
      : [question.id]
    if (updateCommand && updatedId == question.id) {
      updateState({quizQuestionBank: {[index]: updateCommand}})
    }
  }

  const handlePropertyChange = (name, value) => updateProperties({id: question.id, [name]: value}, {[name]: {$set: value}})

  const onStandardsChange = standards => updateProperties(
    {id: question.id, properties: {...question.properties, standards}},
    {properties: {standards: {$set: standards}}}
  )

  return (
    <Dialog
      open={props.open}
      close={closeDialog}
      dialogClasses={classes}
      dialogMaxWidth="lg"
      TitleComponent={() => (
        <Box className="header">
          <Box className="caption">{translate('bank-question-title')}</Box>
          <IconButton onClick={closeDialog} className="close-icon" size="large">
            <CloseIcon />
          </IconButton>
        </Box>
      )}
    >
      <Box className="content">
        <Box className="properties-container">
          <QuestionProperties index={index} question={question} context={context} />
          <Box className="value-wrapper">
            <QuestionValue context={context} className="value" question={question} updateProperties={updateProperties} />
          </Box>
        </Box>
        <Box className="standards">
          <AddStandard question={question} onStandardsChange={onStandardsChange} />
        </Box>
        {Handler && <Handler
            index={index}
            context={context}
            onPropertyChange={handlePropertyChange}
            updateProperties={updateProperties}
            question={question}
            questionPath={questionPath}
          />}
      </Box>
    </Dialog>
  );
}

function editQuestionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
        "& .header" : {
          display: "flex",
          color: '#69738c',
          "& .close-icon": {
            padding: '0 6px',
            "& svg": {
              fontSize: '13pt'
            }
          },
          "& .caption": {
            flexGrow: 1,
            ...verticalCentering
          },
        },
      "& .standards": {
        marginBottom: 10,
      },
      '& .properties-container': {
        display: 'flex',
        marginTop: 20,
        marginBottom: 30,
        padding: 9,
      },
      '& .value-wrapper': {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 10,
        padding: 9,
        '& > .value': {
          width: 75,
          '& > .label': {
           margin: '-8px'
          },
          '& > .valueLabel': {
            color: '#4e566b'
          },
          '& > .valueInput': {
            display: 'flex',
            // border: 'solid 1px black',
            borderRadius: 4,
            cursor: 'text',
            marginTop: 10,
            '& .control': {
              display: 'flex',
            },
            '& .input-wrapper': {
              flexGrow: 1,
              ...verticalCentering
            },
            '& .input': {
              border: 'none',
              width: '100%',
              flexGrow: 1,
              '&:focus': {
                outline: 'none'
              }
            },
            '& .addornment': {
              cursor: 'pointer',
              marginTop: -3,
              ...verticalCentering
            }
          },
        },
      },
    },
    paper: {
      width: 'calc(100% - 64px)'
    }
  }
}
